import { createContext } from 'react';

export const RunCustomerSlugContext = createContext<string | null>(null);
